const getCustomPeriodDates = (activePeriod, startDate, endDate) => {
  if (activePeriod !== 'custom_period') {
    return {};
  }

  const dates = {};
  if (startDate) {
    dates.start_date =
      startDate instanceof Date ? startDate.toISOString() : startDate;
  }
  if (endDate) {
    dates.end_date = new Date(
      new Date(endDate).setHours(23, 59, 59, 999)
    ).toISOString();
  }
  return dates;
};

const getBonusSubscriptionMonths = (
  bonusSubscriptionType,
  bonusSubscriptionMonths
) => {
  if (bonusSubscriptionType === 'NONE') {
    return {};
  }
  return {
    bonus_subscription_months: Number(bonusSubscriptionMonths),
  };
};

const getSalesAvailability = (
  availableForSales,
  salesAccess,
  selectedRegions,
  salesPicList
) => {
  const salesData = {
    available_for_sales: false,
  };

  if (availableForSales) {
    salesData.available_for_sales = salesAccess != null;

    if (salesAccess === 'specific_area') {
      salesData.available_sales_territory_ids = selectedRegions;
    }

    if (
      (salesAccess === 'specific_area' ||
        salesAccess === 'specific_sales_pic') &&
      salesPicList
    ) {
      salesData.available_sales_emails = Array.isArray(salesPicList)
        ? salesPicList
        : salesPicList
            .split(',')
            .map(email => email.trim())
            .filter(email => email.length > 0);
    }
  }

  return salesData;
};

export const createBaseModuleNameOptions = basePackages =>
  basePackages.map(pkg => ({
    key: pkg.id,
    text: pkg.name,
    value: pkg.name,
  }));

export const createSubscriptionProductOptions = basePackages =>
  basePackages.map(pkg => {
    const price = pkg.price_per_month
      ? pkg.price_per_month.toLocaleString('id-ID')
      : '0';
    return {
      key: pkg.id,
      text: `${pkg.name} (Rp ${price}/month)`,
      value: pkg.id,
    };
  });

export const mapPackageToFormValues = packageData => {
  const formValues = {
    ...packageData,
    subscription_product_id: packageData.subscription_product
      ? packageData.subscription_product.id
      : undefined,
    discount_percentage: packageData.discount_rule
      ? packageData.discount_rule.discount_percentage
      : undefined,
    active_period:
      packageData.start_date && packageData.end_date
        ? 'custom_period'
        : 'live_time',
    is_upgrade_product: packageData.is_upgrade_product || false,
    eligible_from_subscription_product:
      packageData.eligible_from_subscription_product || undefined,
  };

  if (packageData.available_for_sales) {
    if (
      packageData.available_sales_territory_ids != null &&
      packageData.available_sales_territory_ids.length > 0
    ) {
      formValues.sales_access = 'specific_area';
      if (
        packageData.available_sales_emails != null &&
        packageData.available_sales_emails.length > 0
      ) {
        formValues.available_sales_emails = packageData.available_sales_emails.join(
          ', '
        );
      }
    } else if (
      packageData.available_sales_emails != null &&
      packageData.available_sales_emails.length > 0
    ) {
      formValues.sales_access = 'specific_sales_pic';
      formValues.available_sales_emails = packageData.available_sales_emails.join(
        ', '
      );
    } else {
      formValues.sales_access = 'all_areas';
    }
  }

  if (formValues.start_date && typeof formValues.start_date === 'string') {
    formValues.start_date = new Date(formValues.start_date);
  }

  if (formValues.end_date && typeof formValues.end_date === 'string') {
    formValues.end_date = new Date(formValues.end_date);
  }

  return formValues;
};

export const mapPackageDataToPayload = (packageData, isEditMode) => {
  return {
    name: packageData.name,
    subscription_product_id: packageData.subscription_product_id,
    type: 'SUBSCRIPTION',
    quantity: Number(packageData.quantity),
    discount_percentage: Number(packageData.discount_percentage),
    available_platforms: packageData.available_platforms,
    available_lead_sources: packageData.available_lead_sources,
    available_for_all_telesales: packageData.available_for_all_telesales,
    bonus_subscription_type: packageData.bonus_subscription_type,
    approval_requirements: packageData.approval_requirements || [],
    is_upgrade_product: Boolean(packageData.is_upgrade_product),
    ...(packageData.is_upgrade_product && {
      eligible_from_subscription_product:
        packageData.eligible_from_subscription_product,
    }),
    ...getCustomPeriodDates(
      packageData.active_period,
      packageData.start_date,
      packageData.end_date
    ),
    ...getBonusSubscriptionMonths(
      packageData.bonus_subscription_type,
      packageData.bonus_subscription_months
    ),
    ...getSalesAvailability(
      packageData.available_for_sales,
      packageData.sales_access,
      packageData.available_sales_territory_ids,
      packageData.available_sales_emails
    ),
    ...(isEditMode && { id: packageData.id }),
  };
};
